import React from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from './components/GlobalStyles'
import './mixins/chartjs';
import theme from './theme';
import Routes from './routes';

const App = (props) => {
  // const routing = useRoutes(routes);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {/* {routing} */}
      <Routes logout={props.logout}/>
    </ThemeProvider>
  );
};

export default App;
